<template>
  <div class="container">
    <p>在学者搜索输入框直接搜索作者姓名进行搜索。</p>
    <img src="../../assets/images/newhelp/help8.png" alt="" />
    <img src="../../assets/images/newhelp/help9.png" alt="" />
    <p>
      点击作者名称进入详情页，可以查看作者的相关信息、研究兴趣、合作机构，下拉还可以查看作者发表的论文情况。论文情况根据需要进行多种筛选排序，帮助您更快定位所需内容。
    </p>
    <img src="../../assets/images/newhelp/help10.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
